import React from "react";
import { SUPPORT_CONTACT } from "../../config";

interface SupportContactProps {
  className?: string;
}

/**
 * The support contact line: name and a tappable number.
 *
 * A component rather than two lines of inline JSX, so the `tel:` href and the
 * visible number can only ever come from the same place — the failure mode
 * being a number updated in one spot and not the other, which is invisible on
 * a desktop and only bites the person trying to phone for help.
 */
export const SupportContact: React.FC<SupportContactProps> = ({
  className = "support-contact",
}) => (
  <div className={className}>
    {SUPPORT_CONTACT.name} &middot;{" "}
    <a href={`tel:${SUPPORT_CONTACT.tel}`}>{SUPPORT_CONTACT.phone}</a>
    {" "}&middot;{" "}
    <a href={`mailto:${SUPPORT_CONTACT.email}`}>{SUPPORT_CONTACT.email}</a>
  </div>
);
